import List from 'layouts/review/ProductReviews.js';
import ProtectedRoute from "routes/protectedRoutes.js";

const ReviewRoutes = [

    {
      route: "/review/list/:pageNo",
      key: "manage-reviews",
      component: <ProtectedRoute check="logout"><List /></ProtectedRoute>
    }

  ];

export default ReviewRoutes;
 